import { defineMessages } from 'react-intl';

export const tailoringMessages = defineMessages({
  bbSectionTitle: {
    id: 'tailoring.page.bbSectionTitle',
    defaultMessage: 'Building Block: {name}',
    description: 'Tailoring page building block section title',
  },
  noBuildingBlockSelected: {
    id: 'tailoring.page.noBuildingBlockSelected',
    defaultMessage: 'No Building Block selected.',
    description: 'Tailoring page no building block selected label',
  },
  includeDesignObligation: {
    id: 'tailoring.page.includeDesignObligation',
    defaultMessage: 'Include Design Obligation',
    description: 'Tailoring page include design obligation button',
  },
  excludeDesignObligation: {
    id: 'tailoring.page.excludeDesignObligation',
    defaultMessage: 'Exclude Design Obligation',
    description: 'Tailoring page exclude design obligation button',
  },
  exclude: {
    id: 'tailoring.page.exclude',
    defaultMessage: 'Exclude',
    description: 'Tailoring page exclude button',
  },
  include: {
    id: 'tailoring.page.include',
    defaultMessage: 'Include',
    description: 'Tailoring page include button',
  },
});
